import chance from 'chance';

const chance_ = chance.Chance()

export default {
	data() {
		return {
			chance: chance_
		}
	}
}